import "../css/project.css";
import CardProjects from "../components/cardProyects";

import { Carousel } from "@mantine/carousel";

import { DataProjects } from "../helpers/dataProjects";

import { useTranslation } from "react-i18next";
const Project = () => {
  const [t] = useTranslation("global");

  return (
    <div className="containerDivProject" id="projects">
      <h1 data-aos="fade-up-right">{t("Projects.titleProject")}</h1>
      <Carousel
        withIndicators
        height={610}
        slideSize="100%"
        loop
        align="start"
        slidesToScroll={1}
        breakpoints={[
          { maxWidth: "md", slideSize: "50%" },
          { maxWidth: "sm", slideSize: "100%", slideGap: 0 },
        ]}
      >
        {DataProjects.map(
          ({
            id,
            img,
            linkPage,
            linkCode,
            transition,
            comingSoon,
            tecnologies,
          }) => {
            return (
              <Carousel.Slide>
                <CardProjects
                  key={id}
                  img={img}
                  linkPage={linkPage}
                  linkCode={linkCode}
                  transition={transition}
                  comingSoon={comingSoon}
                  tecnologies={tecnologies}
                />
              </Carousel.Slide>
            );
          }
        )}
      </Carousel>
    </div>
  );
};
export default Project;
